var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.581,
    height: 22.754,
    viewBox: "0 0 22.581 22.754",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_6427",
    x: 0,
    y: 0,
    width: 22.581,
    height: 22.754,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_6428",
    x: 11.725,
    y: 0.319,
    width: 10.457,
    height: 10.32,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5861",
    "data-name": "Group 5861",
    transform: "translate(-55 -756)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 55, 756)",
    filter: "url(#Path_6427)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6427-2",
    "data-name": "Path 6427",
    d: "M2322.122,54.654q-1.111-1.183-2.225-2.364a.645.645,0,0,0-1.036-.009L2316.39,54.9q-2.565,2.727-5.131,5.452a.578.578,0,0,0-.123.653.588.588,0,0,0,.533.417c.465.011.93.008,1.4,0,.2,0,.2-.013.2.183q0,3.174,0,6.348a.752.752,0,0,0,.771.816c1,.008,2,0,2.994,0,.1,0,.136-.038.13-.134,0-.052,0-.106,0-.159q0-2.628,0-5.256a1.1,1.1,0,0,1,.046-.353.758.758,0,0,1,.8-.5h2.529a.769.769,0,0,1,.836.837v5.229c0,.335,0,.335.339.335,1.016,0,2.03,0,3.048,0a.76.76,0,0,0,.81-.767c0-2.13,0-4.26,0-6.388,0-.195.013-.211.208-.211.425,0,.851-.01,1.276,0a.562.562,0,0,0,.547-.367.575.575,0,0,0-.07-.65c-.132-.166-.275-.323-.421-.476-.25-.261-.508-.515-.76-.777-.289-.305-.572-.618-.864-.922Z",
    transform: "translate(-2308.08 -49.02)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 55, 756)",
    filter: "url(#Path_6428)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6428-2",
    "data-name": "Path 6428",
    d: "M2323.552,52.344h3.116c.663,0,.6.793.6.793l-.027,2.9c-.114,1.021-.966.48-.966.48l-3.329-3.4S2322.384,52.344,2323.552,52.344Z",
    transform: "translate(-2308.08 -49.02)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.d9df49b30954bb48e4f5b2530302a2a9.svg";
export { ForwardRef as ReactComponent };